import { render } from "./StudentAnnuaire.vue?vue&type=template&id=5dd31aaa"
import script from "./StudentAnnuaire.vue?vue&type=script&lang=js"
export * from "./StudentAnnuaire.vue?vue&type=script&lang=js"

import exportComponent from "/opt/referents/frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__